import { BiPlay } from "react-icons/bi";

const GeneralInput = ({
    orderedNodes,
    selectedNode,
    executeNode,
    executionHistory,
    onSelectValue
}) => {

    if (!selectedNode) return null;

    const parents = orderedNodes.filter(n =>
        n.data?.next?.includes(selectedNode.id)
    );

    if (parents.length === 0) {
        return (
            <div className="general_input_container">
                <div className="general_input_box">
                    <p className="general_input_container_p">No inputs connected</p>
                </div>
            </div>
        );
    }

    const inputs = parents.map(parent => {
        const raw = executionHistory?.[parent.id];

        return {
            id: parent.id,
            label: parent.data?.meta?.label,
            node: parent,
            executed: !!raw,
            output: raw?.output ?? null
        };
    });

    const pending = inputs.filter(i => !i.executed);
    const ready = inputs.filter(i => i.executed);

    const hasOutput = (output) => {
        if (output === null || output === undefined) return false;

        if (Array.isArray(output)) return output.length > 0;

        if (typeof output === "object") return Object.keys(output).length > 0;

        return true; // string, number, boolean
    };

    return (
        <div className="general_input_container">

            {pending.length > 0 && (
                <div className="general_input_block">
                    <p className="general_input_container_p">
                        Pending Inputs
                    </p>

                    {pending.map(p => (
                        <div key={p.id} className="general_input_box">
                            <p>
                                <b>{p.label}</b>
                            </p>

                            <button
                                className="general_input_box_btn"
                                onClick={() => executeNode(p.node)}
                            >
                                <BiPlay /> Execute
                            </button>
                        </div>
                    ))}
                </div>
            )}

            {ready.length > 0 && (
                <div className="general_input_block">
                    <p className="general_input_container_p">
                        Available Inputs
                    </p>

                    {ready.map(r => (
                        <div key={r.id} className="general_input_box">
                            <p className="general_input_box_label">{r.label}</p>

                            {hasOutput(r.output) ? (
                                r.output && typeof r.output === "object" ? (
                                    Object.entries(r.output).map(([key, value]) => (
                                        <div
                                            key={key}
                                            className="general_input_box_btn"
                                            onClick={() =>
                                                onSelectValue?.({
                                                    type: "dynamic",
                                                    sourceNodeId: r.id,
                                                    path: key // or null if primitive
                                                })
                                            }
                                        >
                                            <b>{key}</b>: {String(value)}
                                        </div>
                                    ))
                                ) : (
                                    <div
                                        className="general_input_box_btn"
                                        onClick={() =>
                                            onSelectValue?.({
                                                type: "dynamic",
                                                sourceNodeId: r.id,
                                                path: null // or null if primitive
                                            })
                                        }
                                    >
                                        {String(r.output)}
                                    </div>
                                )
                            ) : (
                                <p>No output was generated</p>
                            )}

                        </div>
                    ))}

                </div>
            )}
        </div>
    );
};

export default GeneralInput;